import useSWR from "swr";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { MaterialGradeLight } from "./types";

export const useMaterialGrades = (query: PaginationQuery, signal: AbortSignal, isAdmin?: boolean) => {
  const api = useApi();
  const prefix = isAdmin ? "/admin" : "";
  const url = buildUrl(`${prefix}/modules/lock_calculator/selects/material_grades`, query);
  return useSWR<Paginated<MaterialGradeLight>, CustomError, string>(url, (requestUrl) =>
    api.get<Paginated<MaterialGradeLight>>({ url: requestUrl, signal }),
  );
};
